import {track} from '@amplitude/analytics-browser';

import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import AMPLITUDE_EVENT_VALUES from '../../consts/amplitude/amplitudeEventValues';
import amplitude from './amplitude';

const trackTradeInLink = (isSmallBanner) => {
    amplitude.trackDeviceEvent(AMPLITUDE_EVENT_TYPES.TRADE_IN_CLICKED, {
        [AMPLITUDE_EVENT_PROPERTIES.SOURCE]: isSmallBanner
            ? AMPLITUDE_EVENT_VALUES.TRADE_IN_DEVICE_SETTINGS_1
            : AMPLITUDE_EVENT_VALUES.TRADE_IN_DEVICE_SETTINGS_2,
    });
};

const trackNearestStoreLink = () => {
    track(AMPLITUDE_EVENT_TYPES.LINK_TO_NEAREST_STORE_OPENED);
};

const trackAnniversaryLearnMoreClick = () => {
    track(AMPLITUDE_EVENT_TYPES.ANNIVERSARY_LEARN_MORE_CLICKED);
};

export default {
    trackTradeInLink,
    trackNearestStoreLink,
    trackAnniversaryLearnMoreClick,
};
